export { handleChangeInputText } from "./lib/handleChangeInputText";
export { handleChangeInputRange } from "./lib/handleChangeInputRange";
export { handleChangeInputRadio } from "./lib/handleChangeInputRadio";
export { handleChangeInputCheckbox } from "./lib/handleChangeInputCheckbox";
export { handleChangeInputTextTable } from "./lib/handleChangeInputTextTable";
export { handleChangeInputTextDinamic } from "./lib/handleChangeInputTextDinamic";
export { handleChangeInputLocation } from "./lib/handleChangeInputLocation";
export { handleChangeInputSpecialRange } from "./lib/handleChangeInputSpecialRange";
export { handleChangeInputRadioDinamic } from "./lib/handleChangeInputRadioDinamic";


// WEBPACK FOOTER //
// src/helpers/index.js